import { render, staticRenderFns } from "./data67.vue?vue&type=template&id=6023f5f6&scoped=true&"
import script from "./data67.vue?vue&type=script&lang=js&"
export * from "./data67.vue?vue&type=script&lang=js&"
import style1 from "./data67.vue?vue&type=style&index=1&id=6023f5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023f5f6",
  null
  
)

export default component.exports